export const STR_APP_NAME = {
  en: "KUMBUKA",
  sw: "KUMBUKA",
};

export const STR_HEALTH = {
  en: "health",
  sw: "afya",
}

export const STR_RELATIONSHIPS = {
  en: "relationships",
  sw: "mahusiano",
}

export const STR_STORIES = {
  en: "stories",
  sw: "masimulizi",
}

export const STR_COURSES = {
  en: "Courses",
  sw: "Kozi",
}


export const STR_GET_STARTED = {
  en: "get started",
  sw: "anza sasa",
}

export const STR_CONTINUE = {
  en: "continue",
  sw: "endelea",
}

export const STR_ENTER = {
  en: "enter",
  sw: "ingia",
}

export const STR_ENTER_YOUR_PHONE_NUMBER = {
  en: "Enter your phone number",
  sw: "Ingiza namba yako ya simu",
}

export const STR_PHONE_NUMBER = {
  en: "Phone number",
  sw: "Namba ya simu",
}

export const STR_ENTER_OTP = {
  en: "Enter the OTP sent to your phone",
  sw: "Ingiza OTP uliotumiwa kwenye simu",
}

export const STR_PLEASE_WAIT = {
  en: "Please wait..",
  sw: "Tafadhali subiri..",
}

export const STR_INVALID_PHONE = {
  en: "Invalid phone number",
  sw: "Namba ya simu sio sahihi",
}

export const STR_INVALID_OTP = {
  en: "Invalid OTP",
  sw: "OTP sio sahihi",
}

export const STR_WELCOME = {
  en: "Welcome..",
  sw: "Karibu..",
}

export const STR_CHANGE_PHONE = {
  en: "Change Phone",
  sw: "Badili Simu",
}

export const STR_RESEND_OTP = {
  en: "Resend OTP",
  sw: "Tuma tena OTP",
}

export const STR_MENU_HOME = {
  en: "Home",
  sw: "Nyumbani",
}

export const STR_MENU_DATING = {
  en: "Dating",
  sw: "Mahusiano",
}

export const STR_MENU_DOCTORS = {
  en: "Doctors",
  sw: "Madaktari",
}

export const STR_MENU_INBOX = {
  en: "Inbox",
  sw: "Ujumbe",
}

export const STR_MENU_ARTICLES = {
  en: "Articles",
  sw: "Makala",
}

export const STR_MENU_STORIES = {
  en: "Stories",
  sw: "Simulizi",
}

export const STR_MENU_UTILITIES = {
  en: "Utilities",
  sw: "Visaidizi",
}

export const STR_LATEST_ARTICLES = {
  en: "Latest Articles",
  sw: "Makala Mpya",
}

export const STR_MORE_ARTICLES = {
  en: "More Articles",
  sw: "Makala Zaidi",
}

export const STR_LATEST_STORIES = {
  en: "Latest Stories",
  sw: "Simulizi Mpya",
}

export const STR_LATEST_COURSES = {
  en: "Latest Courses",
  sw: "Kozi Mpya",
}

export const STR_MORE_STORIES = {
  en: "More Stories",
  sw: "Simulizi Zaidi",
}

export const STR_MORE_COURSES = {
  en: "More Courses",
  sw: "Kozi Zaidi",
}

export const STR_PERSONAL_SETTINGS = {
  en: "Personal Settings",
  sw: "Mipangilio Binafsi",
}

export const STR_UPDATE_USERNAME = {
  en: "Update username",
  sw: "Badili/Weka jina",
}

export const STR_CHANGE_PHONE_NUMBER = {
  en: "Change phone number",
  sw: "Badili namba ya simu",
}

export const STR_UPDATE_PERSONAL_INFO = {
  en: "Update personal information",
  sw: "Badili/Weka taarifa binafsi",
}

export const STR_PAYMENT_SETTINGS = {
  en: "Payments",
  sw: "Malipo",
}

export const STR_SUBSCRIPTION_FEE_PAYMENTS = {
  en: "My Subscription",
  sw: "Kifurushi cha matumizi",
}

export const STR_CONSULTATION_FEE_PAYMENTS = {
  en: "Doctor's consultation fee payment",
  sw: "Malipo ya kuwasiliana na daktari",
}

export const STR_MY_SUBSCRIPTION = {
  en: "My Subscription",
  sw: "Kifurushi cha matumizi",
}

export const STR_SUBSCRIPTION_HAS_EXPIRED = {
  en: "Subscription has expired",
  sw: "Kifurushi kimeisha",
}

export const STR_PURCHASE_SUBSCRIPTION_PACKAGE = {
  en: "Purchase a subscription package to continue using all features in this app",
  sw: "Nunua kifurushi cha matumizi ili kuendelea kutumia kila kitu kwenye App hii",
}

export const STR_SELECT = {
  en: "Select",
  sw: "Chagua",
}

export const STR_COMPLETE_PAYMENT = {
  en: "Complete Payment",
  sw: "Kamilisha Malipo",
}

export const STR_PAY_WITH_CARD = {
  en: "Pay with Credit Card",
  sw: "Lipia kwa Kadi",
}

export const STR_PAY_WITH_MOBILE = {
  en: "Pay with Mobile Network",
  sw: "Lipia kwa Mtandao wa Simu",
}

export const STR_SELECT_PAYMENT_METHOD = {
  en: "Select payment method",
  sw: "Chagua njia ya kufanya malipo",
}

export const STR_ENTER_PHONE_NUMBER_FOR_PAYMENT = {
  en: "Enter phone number you want to use for this payment. All Tanzanian networks are supported.",
  sw: "Ingiza namba ya simu utakayofanyia malipo. Tunapokea kutoka mitandao yote ya Tanzania",
}

export const STR_FINALIZE_PAYMENT_CARD = {
  en: "Please wait, you'll soon be redirected to complete the payment with your card.",
  sw: "Tafadhali subiri utaelekezwa kwenye kiungo cha kufanyia malipo kwa kadi yako",
}

export const STR_FINALIZE_PAYMENT_MOBILE = {
  en: "Push USSD was sent to your phone please check and finalize the payment",
  sw: "Tafadhali angalia simu yako ili kukamilisha malipo kwa USSD Push",
}

export const STR_BUY_NOW = {
  en: "Buy Now",
  sw: "Nunua Sasa",
}

export const STR_DAYS = {
  en: "Days",
  sw: "Siku",
}

export const STR_FROM = {
  en: "From",
  sw: "Kuanzia",
}

export const STR_TO = {
  en: "To",
  sw: "Hadi",
}

export const STR_PRICE = {
  en: "Price",
  sw: "Bei",
}

export const STR_PASSWORD = {
  en: "Password",
  sw: "Nenosiri",
}

export const STR_CONFIRM = {
  en: "Confirm",
  sw: "Hakiki",
}

export const STR_INVALID_PASSWORD = {
  en: "Invalid Password, password must have atleast 8 characters",
  sw: "Nenosiri angalau liwe na muunganiko wa namba na herufi angalau 8",
}

export const STR_INVALID_CONFIRM_PASSWORD = {
  en: "Please confirm your password correctly",
  sw: "Tafadhali hakiki nenosiri lako kwa usahihi",
}

export const STR_CHANGE_LANGUAGE = {
  en: "Tumia Swahili",
  sw: "Change to English",
}

export const STR_FORGOT_PASSWORD = {
  en: "Forgot Password",
  sw: "Nimesahau Nenosiri",
}

export const STR_NO = {
  en: "No",
  sw: "Hapana",
}

export const STR_YES = {
  en: "Yes",
  sw: "Ndio",
}

export const STR_BOND_CALCULATOR = {
  en: "Bonds Calculator",
  sw: "Kikokotozi Hatifungani",
}

export const STR_LOAN_CALCULATOR = {
  en: "Loans Calculator",
  sw: "Kikokotozi Mikopo",
}

export const STR_UTT_CALCULATOR = {
  en: "UTT AMIS Calculators",
  sw: "Vikokotozi vya UTT AMIS",
}

export const STR_BOOKS_LIBRARY = {
  en: "Books' Library",
  sw: "Maktaba ya Vitabu",
}

export const STR_INTRO_1 = {
  en: "KUMBUKA",
  sw: "KUMBUKA",
}

export const STR_INTRO_2 = {
  en: "The easiest way to broadcast messages and reminders to customers or yourself",
  sw: "Njia rahisi ya kutuma ujumbe na ukumbusho kwa wateja au kwako binafsi",
}

export const STR_TRACK = {
  en: "Track",
  sw: "Fuatilia",
}

export const STR_LEARN = {
  en: "Learn",
  sw: "Jifunze",
}

export const STR_ACCOUNT = {
  en: "Account",
  sw: "Akaunti",
}

export const STR_INCOME = {
  en: "Income",
  sw: "Kipato",
}

export const STR_SAVINGS = {
  en: "Savings",
  sw: "Akiba",
}

export const STR_EXPENSES = {
  en: "Expenses",
  sw: "Matumizi",
}

export const STR_DEBTS = {
  en: "Debts",
  sw: "Madeni",
}

export const STR_CHARITY = {
  en: "Charity",
  sw: "Matoleo",
}

export const STR_INVESTMENTS = {
  en: "Investments",
  sw: "Uwekezaji",
}

export const STR_INSURANCE = {
  en: "Insurance",
  sw: "Bima",
}

export const STR_VIEW_MORE = {
  en: "View More...",
  sw: "Ona Zaidi...",
}

export const STR_TOTAL = {
  en: "Total",
  sw: "Jumla",
}

export const STR_RECORD = {
  en: "Record",
  sw: "Rekodi",
}

export const STR_SET_GOAL = {
  en: "Set Goal",
  sw: "Weka Lengo",
}

export const STR_RECORD_INCOME = {
  en: "Record Income",
  sw: "Rekodi Kipato",
}

export const STR_DESCRIPTON = {
  en: "Description",
  sw: "Maelezo",
}

export const STR_AMOUNT = {
  en: "Amount (in your currency)",
  sw: "Kiasi (kwa sarafu yako)",
}

export const STR_DATE = {
  en: "Date",
  sw: "Tarehe",
}

export const STR_CATEGORY = {
  en: "Category",
  sw: "Aina",
}

export const STR_OPTIONAL = {
  en: "Optional",
  sw: "Sio lazima",
}

export const STR_SUBMIT = {
  en: "Submit",
  sw: "Wasilisha",
}

export const STR_INVALID_AMOUNT = {
  en: "Invalid Amount",
  sw: "Kiasi sio sahihi",
}

export const STR_INVALID_DATE = {
  en: "Invalid date",
  sw: "Tarehe sio sahihi",
}

export const STR_INVALID_CATEGORY = {
  en: "Invalid category",
  sw: "Aina sio sahihi",
}

export const STR_SUCCESS = {
  en: "Succcess",
  sw: "Imefanikiwa",
}

export const STR_ERROR = {
  en: "UnSucccess",
  sw: "Haijafanikiwa",
}

export const STR_HISTORY = {
  en: "History",
  sw: "Historia",
}

export const STR_GOALS = {
  en: "Goals",
  sw: "Malengo",
}

export const STR_PERIOD_ALL_TIME = {
  en: "All time",
  sw: "Muda wote",
}

export const STR_PERIOD_WEEK = {
  en: "This week",
  sw: "Wiki hii",
}

export const STR_PERIOD_MONTH = {
  en: "This month",
  sw: "Mwezi huu",
}

export const STR_NO_RECORD = {
  en: "No record",
  sw: "Hakuna taarifa kwa sasa",
}

export const STR_UPDATE = {
  en: "Edit",
  sw: "Hariri",
}

export const STR_RECORD_SAVINGS = {
  en: "Record Savings",
  sw: "Rekodi Akiba",
}

export const STR_RECORD_EXPENSES = {
  en: "Record Expenses",
  sw: "Rekodi Matumizi",
}

export const STR_RECORD_CHARITY = {
  en: "Record Charity",
  sw: "Rekodi Matoleo",
}

export const STR_RECORD_INVESTMENT = {
  en: "Record Investment",
  sw: "Rekodi Uwekezaji",
}

export const STR_RECORD_INSURANCE = {
  en: "Record Insurance",
  sw: "Rekodi Bima",
}

export const STR_RECORD_DEBT = {
  en: "Record Debt",
  sw: "Rekodi Deni",
}

export const STR_CANNOT_PROCESS_REQUEST = {
  en: "Cannot process request",
  sw: "Haiwezi kukamilisha ombi lako kwa sasa",
}

export const STR_OPERATION_FAILED = {
  en: "Operation failed",
  sw: "Imeshindwa kuendelea",
}

export const STR_PROJECTIONS = {
  en: "Projections",
  sw: "Matarajio",
}

export const STR_CREATE_NEW_GOAL = {
  en: "Create New Goal",
  sw: "Weka Lengo Jipya",
}

export const STR_START_DATE = {
  en: "Start Date",
  sw: "Tarehe ya kuanza",
}

export const STR_END_DATE = {
  en: "End Date",
  sw: "Tarehe ya kumaliza",
}

export const STR_INVALID_START_DATE = {
  en: "Invalid Start date",
  sw: "Tarehe ya kuanzia sio sahihi",
}

export const STR_INVALID_END_DATE = {
  en: "Invalid end date",
  sw: "Tarehe ya kumalizia sio sahihi",
}

export const STR_NOT_EDITABLE_WARN = {
  en: "You won't be able to edit details after creating",
  sw: "Hautoweza kuhariri taarifa baada ya kutengeneza",
}

export const STR_TARGET = {
  en: "Target",
  sw: "Lengo",
}

export const STR_ACTUAL = {
  en: "Actual",
  sw: "Halisi",
}

export const STR_DELETE_GOAL = {
  en: "Delete this goal",
  sw: "Futa lengo hili",
}

export const STR_DELETE = {
  en: "Delete",
  sw: "Futa",
}

export const STR_PROJECTIONS_INTO_TEXT = {
  en: "These projections assume that you continue with your current progress in the selected factor for a selected period",
  sw: "Makadirio haya ni endapo ukiendeleza utaratibu ulionao kwenye nguzo husika ndani ya kipindi ulichochagua",
}

export const STR_AMOUNT_PER_DAY = {
  en: "Amount per Day",
  sw: "Kiasi kwa Siku",
}

export const STR_TOTAL_AMOUNT = {
  en: "Total Amount",
  sw: "Jumla",
}

export const STR_TOTAL_EXPECTED_AMOUNT = {
  en: "Total Expected Amount",
  sw: "Jumla Inayotegemewa",
}

export const STR_SELECT_PERIOD = {
  en: "Select Period",
  sw: "Chagua kipindi",
}

export const STR_AFTER_ONE_MONTH = {
  en: "After One Month",
  sw: "Baada ya Mwezi Mmoja",
}

export const STR_AFTER_ONE_WEEK = {
  en: "After One Week",
  sw: "Baada ya Wiki Moja",
}


export const STR_AFTER_6_MONTHS = {
  en: "After Six Months",
  sw: "Baada ya Miezi Sita",
}

export const STR_AFTER_ONE_YEAR = {
  en: "After One Year",
  sw: "Baada ya Mwaka Mmoja",
}

export const STR_AFTER_TWO_YEARS = {
  en: "After Two Years",
  sw: "Baada ya Miaka Miwili",
}

export const STR_AFTER_FIVE_YEARS = {
  en: "After Five Years",
  sw: "Baada ya Miaka Mitano",
}

export const STR_LEARN_MORE = {
  en: "Learn More...",
  sw: "Mafunzo Zaidi...",
}

export const STR_CALCULATORS = {
  en: "Calculators",
  sw: "Vikokotozi",
}

export const STR_CONTACT_US = {
  en: "Contact Us",
  sw: "Wasiliana Nasi",
}

export const STR_INTEREST_RATE = {
  en: "Annual Interest Rate",
  sw: "Kiwango cha Riba kwa mwaka",
};

export const STR_LOAN_TERM = {
  en: "Loan Term",
  sw: "Muda wa Mkopo",
};

export const STR_MONTHLY_PAYMENT = {
  en: "Monthly Payment",
  sw: "Marejesho ya Kila Mwezi",
};

export const STR_TOTAL_INTEREST = {
  en: "Total Interest",
  sw: "Jumla ya Riba",
};

export const STR_TOTAL_PAYMENT = {
  en: "Total Payment",
  sw: "Jumla ya Malipo",
};

export const STR_INVALID_INTEREST_RATE = {
  en: "Invalid interest rate",
  sw: "Kiwango cha riba sio sahihi",
};

export const STR_INVALID_LOAN_TERM = {
  en: "Invalid loan term",
  sw: "Muda wa mkopo sio sahihi",
};


export const STR_CALCULATE = {
  en: "Calculate",
  sw: "Kokotoa",
};

export const STR_IN_PERCENT = {
  en: "In Percentage (%)",
  sw: "Kwa asilimia (%)",
}

export const STR_IN_MONTHS = {
  en: "In Months",
  sw: "Kwa miezi",
}

export const STR_TERM_TYPE = {
  en: "Loan Term Type",
  sw: "Aina ya Muda wa Mkopo",
};

export const STR_SELECT_TERM_TYPE = {
  months: {
    en: "Months",
    sw: "Miezi",
  },
  years: {
    en: "Years",
    sw: "Miaka",
  },
};

export const STR_PAYMENT_FREQUENCY = {
  en: "Payment Frequency",
  sw: "Utaratibu wa Malipo",
};

export const STR_SELECT_FREQUENCY = {
  monthly: {
    en: "Monthly",
    sw: "Kila Mwezi",
  },
  quarterly: {
    en: "Quarterly",
    sw: "Kila Robo Mwaka",
  },
  annually: {
    en: "Annually",
    sw: "Kila Mwaka",
  },
};

export const STR_REPAYMENT = {
  en: "Payment",
  sw: "Rejesho",
}


export const STR_BOND_TERM = {
  en: "Bond Term (years)",
  sw: "Muda wa Kuiva (miaka)",
};

export const STR_ANNUAL_COUPON_PAYMENT = {
  en: "Coupon Payment",
  sw: "Malipo",
};

export const STR_TOTAL_COUPON_PAYMENT = {
  en: "Total Coupon Payment",
  sw: "Jumla ya Malipo",
};


export const STR_INVALID_BOND_TERM = {
  en: "Invalid bond term",
  sw: "Muda wa deni usiofaa",
};

export const STR_UTT_MONTHLY_INVESTMENT_CALC = {
  en: "UTT Monthly Investment Calculator",
  sw: "UTT: Kokotoa Uwekezaji wa Kila Mwezi",
}

export const STR_UTT_SINGLE_SUM_INVESTMENT_CALC = {
  en: "UTT Single Sum Investment Calculator",
  sw: "UTT: Kokotoa Uwekezaji wa Mara moja usiojirudia",
}

export const STR_EMAIL = {
  en: "Email Address",
  sw: "Anwani ya Barua pepe",
}

export const STR_INVALID_EMAIL = {
  en: "Invalid email",
  sw: "Anwani ya barua pepe sio sahihi",
}

export const STR_NOTIFICATIONS = {
  en: "Notifications",
  sw: "Taarifa",
}

export const STR_USE_EMAIL = {
  en: "Use Email",
  sw: "Barua Pepe",
}

export const STR_USE_PHONE = {
  en: "Use Phone",
  sw: "Namba ya Simu",
}

export const STR_ENTER_EMAIL_ADDRESS = {
  en: "Enter your email address",
  sw: "Weka anwani yako ya barua pepe",
}


export const STR_LOGIN_TO_CONTINUE = {
  en: "Login to continue",
  sw: "Ingia ili kuendelea",
}

export const STR_LOGIN_NOW = {
  en: "Login now",
  sw: "Ingia Sasa",
}

export const STR_CHANGE = {
  en: "Change",
  sw: "Badili",
}

export const STR_MONTHLY_INVESTMENT = {
  en: "Monthly Investment",
  sw: "Uwekezaji wa Kila Mwezi",
};

export const STR_EXPECTED_RETURN = {
  en: "Expected Annual Return",
  sw: "Faida Inayotarajiwa Kila Mwaka",
};

export const STR_INVESTMENT_PERIOD = {
  en: "Investment Duration in Years",
  sw: "Kipindi cha Uwekezaji kwa Miaka",
};

export const STR_TOTAL_INVESTMENT = {
  en: "Total Investment",
  sw: "Jumla ya Uwekezaji",
};

export const STR_EXPECTED_AMOUNT = {
  en: "Expected Amount",
  sw: "Kiasi Kinachotarajiwa",
};

export const STR_WEALTH_GAIN = {
  en: "Wealth Gain",
  sw: "Faida Itakayopatikana",
};

export const STR_SINGLE_SUM_INVESTMENT = {
  en: "Single Sum Investment",
  sw: "Uwekezaji wa Mara Moja",
};

export const STR_ARTICLES = {
  en: "Articles on how to build wealth",
  sw: "Makala za namna ya kujijengea Utajiri",
}

export const STR_RECORD_REPAYMENT = {
  en: "Record Repayment",
  sw: "Rekodi Marejesho",
}

export const STR_RECORD_RETURNS = {
  en: "Record Returns",
  sw: "Rekodi faida ya uwekezaji",
}

export const STR_ORIGINAL_AMOUNT = {
  en: "Original Amount",
  sw: "Kiasi cha mwanzo",
}

export const STR_REPAYMENTS = {
  en: "Repayments",
  sw: "Marejesho",
}

export const STR_RETURNS = {
  en: "Returns",
  sw: "Faida kwenye uwekezaji",
}

export const STR_LOGOUT = {
  en: "Log Out",
  sw: "Ondoka Kwenye Akaunti",
}

export const STR_SET_CURRENCY = {
  en: "Set Currency",
  sw: "Panga Sarafu",
}


export const STR_SELECT_CURRENCY_TO_USE = {
  en: "Select currency to use",
  sw: "Chagua sarafu ya kutumia",
}

export const STR_INVALID_CURRENCY = {
  en: "Invalid currency",
  sw: "Sarafu sio sahihi",
}

export const STR_MY_COACH = {
  en: "My Coach",
  sw: "Kocha Wangu",
}

export const STR_ENTER_COACH_PHONE = {
  en: "Enter your coach's phone (with country code)",
  sw: "Ingiza namba ya simu ya kocha wako ikiwa na country code",
}

export const STR_ENTER_FULLNAME = {
  en: "Enter your name as recognized by this coach",
  sw: "Ingiza jina lako kama unavyotabulika kwa kocha huyu",
}

export const STR_INVALID_NAME = {
  en: "Invalid name",
  sw: "Jina sio sahihi",
}

export const STR_MY_STUDENTS = {
  en: "My Students",
  sw: "Wanafunzi wangu",
}

export const STR_USER_REPORT = {
  en: "Report",
  sw: "Ripoti",
}

export const STR_BREAKDOWN = {
  en: "Breakdown",
  sw: "Mchanganuo",
}

export const STR_MESSAGES = {
  en: "Messages",
  sw: "Ujumbe",
}

export const STR_CONTACTS = {
  en: "Contacts",
  sw: "Mawasiliano",
}

export const STR_INDIVIDUALS = {
  en: "Individuals",
  sw: "Mmoja Mmoja",
}

export const STR_GROUPS = {
  en: "Groups",
  sw: "Makundi",
}

export const STR_CREATE_NEW_CONTACT = {
  en: "Create New Contact",
  sw: "Unda Mawasiliano Mapya",
}

export const STR_NAME = {
  en: "Name",
  sw: "Jina",
}

export const STR_WHATSAPP_NUMBER = {
  en: "Whatsapp Number",
  sw: "Namba ya Whatsapp",
}

export const STR_INVALID_WHATSAPP_NUMBER = {
  en: "Invalid whatsapp number",
  sw: "Namba ya whatsapp sio sahihi",
}

export const STR_FILTER_BY_NAME_OR_PHONE = {
  en: "Filter by name or phone",
  sw: "Chambua kwa simu au jina",
}

export const STR_FILTER_BY_NAME = {
  en: "Filter by name",
  sw: "Chambua kwa jina",
}

export const STR_CREATE_NEW_CONTACT_GROUP = {
  en: "Create New Contact Group",
  sw: "Unda Kundi la Mawasiliano",
}

export const STR_CREATE_NEW = {
  en: "Create New",
  sw: "Unda Mpya",
}

export const STR_MESSAGE_TITLE = {
  en: "Message Title",
  sw: "Kichwa cha Ujumbe",
}

export const STR_INVALID_TITLE = {
  en: "Invalid title",
  sw: "Kichwa sio sahihi",
}

export const STR_MESSAGE_BODY = {
  en: "Message Body",
  sw: "Ujumbe",
}

export const STR_INVALID_BODY = {
  en: "Invalid body",
  sw: "Ujumbe sio sahihi",
}

export const STR_MESSAGE_TO_BE_SENT = {
  en: "Message to be sent. Use code <name> to dynamically include receiver's name, this may slightly alter SMS length and count when sending",
  sw: "Ujumbe utakaotumwa. Tumia kodi <name> kuingiza jina la mpokeaji kiotomatiki. Jina linaweza kubadilisha urefu wa ujumbe wakati wa kutuma",
}

export const STR_SEND = {
  en: "Send",
  sw: "Tuma",
}

export const STR_WHATSAPP_MESSAGE = {
  en: "WhatsApp Message",
  sw: "Ujumbe wa WhatsApp",
}

export const STR__NORMAL_SMS = {
  en: "Normal SMS",
  sw: "Ujumbe wa Kawaida",
}

export const STR_MESSAGE_TYPE = {
  en: "Message Type",
  sw: "Aina ya Ujumbe",
}

export const STR_SENDER_ID = {
  en: "Sender ID",
  sw: "Sender ID",
}

export const STR_IMAGE = {
  en: "Image",
  sw: "Picha",
}

export const STR_RECEPIENTS = {
  en: "Recepients",
  sw: "Wapokeaji",
}

export const STR_INVALID_RECEPIENTS = {
  en: "Invalid Recepients",
  sw: "Wapokeaji sio sahihi",
}

export const STR_INVALID_MESSAGE = {
  en: "Invalid Message",
  sw: "Ujumbe sio sahihi",
}

export const STR_EDIT = {
  en: "Edit",
  sw: "Hariri",
}

export const STR_ALL = {
  en: "All",
  sw: "Wote",
}

export const STR_SUCCESSFULLY_SENT = {
  en: "Successfully Sent",
  sw: "Waliotumiwa Kikamilifu",
}

export const STR_SEND_FAILED = {
  en: "Send Failed",
  sw: "Walioshindwa kutumiwa",
}

export const STR_VIEW_GROUP = {
  en: "View Group",
  sw: "Fungua Kundi",
}

export const STR_WHATSAPP_SETUP = {
  en: "WhatsApp Setup",
  sw: "Mipangilio ya WhatsApp",
}

export const STR_WHATSAPP_QR_HELPER = {
  en: "Open your WhatsApp APP, click 'Linked Devices' then scan this code below to integrate your WhatsApp Account",
  sw: "Fungua APP yako ya WhatsApp kisha bofya 'Linked Devices' na scan code hii hapo chini ili kuunga whatsapp yako",
}

export const STR_WHATSAPP_BOT_STATUS = {
  en: "WhatsApp Integration Status",
  sw: "Hali ya Kuunganishwa na WhatsApp",
}

export const STR_WHATSAPP_QR_LAST_UPDATED = {
  en: "QR code last updated",
  sw: "Mara ya mwisho kuunda QR code",
}

export const STR_SCHEDULE_MESSAGE = {
  en: "Schedule Message",
  sw: "Tuma Baadae",
}

export const STR_SCHEDULED_AT = {
  en: "Scheduled At",
  sw: "Muda wa Kutuma",
}

export const STR_INTEGRATE_NOW = {
  en: "Integrate Now",
  sw: "Unganisha Sasa",
}

export const STR_SUBSCRIPTION_TYPE = {
  en: "Subscription Type",
  sw: "Aina ya kifurushi",
}

export const STR_SUBSCRIPTION_AMOUNT = {
  en: "Quantity",
  sw: "Idadi",
}

export const STR_ENTER_DETAILS = {
  en: "Enter Details",
  sw: "Weka Taarifa",
}

export const STR_UPLOAD_FILE = {
  en: "Upload File",
  sw: "Pakia Faili",
}

export const STR_EXCEL_FILE_HELPER_TEXT = {
  en: "Upload excel file with columns in this order: Name, Phone number, Whatsapp number",
  sw: "Chagua faili la excel lenye mpangilio huu: Jina, Namba ya Simu, Namba ya Whatsapp",
}

export const STR_EXCEL_FILE_HELPER_TEXT_GROUP = {
  en: "Upload contacts to this group as excel file with columns in this order: Name, Phone number, Whatsapp number",
  sw: "Pakia mawasiliano kwenye group hili kwa fail la excel lenye mpangilio huu: Jina, Namba ya Simu, Namba ya Whatsapp",
}

export const STR_FILE = {
  en: "File",
  sw: "Faili",
}

export const STR_INVALID_FILE = {
  en: "Invalid File",
  sw: "Faili sio sahihi",
}

export const STR_REQUESTS = {
  en: "Requests",
  sw: "Maombi",
}

export const STR_REGISTERED = {
  en: "Registered",
  sw: "Zilizosajiliwa",
}

export const STR_REQUEST_SENDER_ID = {
  en: "Request Sender ID",
  sw: "Tuma maombi ya Sender ID",
}

export const STR_FULLNAME = {
  en: "Your Fullname",
  sw: "Jina lako kamili",
}

export const STR_SAMPLE_SMS = {
  en: "Sample SMS",
  sw: "Ujumbe wa majaribio",
}

export const STR_INVALID_SENDER_ID = {
  en: "Invalid Sender ID",
  sw: "Sender ID sio sahihi",
}

export const STR_INVALID_SAMPLE_SMS = {
  en: "Invalid Sample SMS",
  sw: "Ujumbe wa majaribio sio sahihi",
}

export const STR_GO_BACK = {
  en: "Go Back",
  sw: "Rudi",
}

export const STR_REGISTRATION_STATUS = {
  en: "Registration status",
  sw: "Hali ya usajili",
}

export const STR_PAYMENT_STATUS = {
  en: "Payment status",
  sw: "Hali ya malipo",
}

export const STR_DATE_REQUESTED = {
  en: "Date Requested",
  sw: "Tarehe ya maombi",
}

export const STR_DELETE_GROUP_WARNING = {
  en: "Are you sure you want to delete this group?",
  sw: "Una hakika unataka kufuta group hili?",
}

export const STR_DELETE_CONTACT_WARNING = {
  en: "Are you sure you want to delete this contact?",
  sw: "Una hakika unataka kufuta mawasiliano haya?",
}

export const STR_MESSAGE_LOGS = {
  en: "Messaging Results",
  sw: "Matokeo ya Utumaji",
}

export const STR_PENDING = {
  en: "Pending",
  sw: "Pending",
}

export const STR_MESSAGE_LOGS_HELP_TEXT_1 = {
  en: "No results yet. Results will be available when sending begins",
  sw: "Hakuna matokeo kwa sasa, matokeo yatapatikiana utumaji ukianza",
}

export const STR_WHATSAPP_LOGOUT = {
  en: "Whatsapp Account Logout",
  sw: "Ondoa Whatsapp Akaunti",
}

export const STR_INTEGRATED_APPS = {
  en: "Integrated Apps",
  sw: "App Zilizounganishwa",
}

export const STR_INTEGRATE_NEW_ACCOUNT = {
  en: "Integrate new Account",
  sw: "Unganisha Akaunti Mpya",
}

export const STR_BUSINESS_CODE = {
  en: "Business Code",
  sw: "Msimbo wa Biashara",
}

export const STR_INVALID_BUSINESS_CODE = {
  en: "Invalid Business Code",
  sw: "Msimbo wa biashara sio sahihi",
}

export const STR_SEND_MESSAGE_TO_CLIENTS = {
  en: "Send Message to Clients",
  sw: "Tuma ujumbe kwa wateja kamili",
}

export const STR_SEND_MESSAGE_TO_LEADS = {
  en: "Send Message to Leads",
  sw: "Tuma ujumbe kwa wateja tarajiwa",
}

export const STR_LEADS = {
  en: "Leads",
  sw: "Wateja Tarajiwa",
}

export const STR_CLIENTS = {
  en: "Clients",
  sw: "Wateja Kamili",
}

export const STR_SEND_MESSAGE = {
  en: "Send Message",
  sw: "Tuma Ujumbe",
}

export const STR_VIEW_INTEGRATED_APP = {
  en: "View Integrated App",
  sw: "Ona App Iliounganishwa",
}

export const STR_VIEW_INTEGRATED_ACCOUNT = {
  en: "View Integrated Account",
  sw: "Ona Akaunti Iliounganishwa",
}

export const STR_SMS_COUNT = {
  en: "SMS Count",
  sw: "Idadi ya Jumbe",
}

export const STR_CHARACTERS_COUNT = {
  en: "Chars Count",
  sw: "Idadi ya Herufi",
}

export const STR_ONLY_ALPHANUMERIC_CHARACTES = {
  en: "Do not use special characters",
  sw: "Usitumie alama au herufi zisizo za kawaida",
}

export const STR_REPORT_PROBLEM = {
  en: "Report Problem",
  sw: "Ripoti Tatizo",
}

export const STR_DESCRIPTION_SUMMARY = {
  en: "Please write the problem you encountered and send it, We will reach you soon.",
  sw: "Tafadhali andika tatizo ulilopata kisha tuma, Tutakufikia punde.",
}


export const STR_DESCRIPTION = {
  en: "Description",
  sw: "Maelezo",
}

export const STR_DOWNLOAD_CONTACT_WARNING = {
  en: "Are you sure you want to download this contact?",
  sw: "Una hakika unataka kupakua mawasiliano haya?",
}

export const STR_CONNECT_WHATSAPP = {
  en: "Connect your WhatsApp first",
  sw: "Unganisha WhatsApp yako kwanza",
}

export const STR_INITIALIZE_WHATSAPP = {
  en: "Initialize WHatsApp",
  sw: "Anzisha WhatsApp",
}

export const STR_ = {
  en: "",
  sw: "",
}





